import Vue from 'vue'
import VueRouter from 'vue-router'
// import ServiceAgreement from '../views/service-agreement'
import DownLoad from '../views/download.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'DownLoad',
    component: DownLoad,
    meta: {
      title: '操作指引'
    }
  },
  {
    path: '/download',
    name: 'DownLoad',
    component: () => import(/* webpackChunkName: "about" */ '../views/download.vue'),
    meta: {
      title: '操作指引'
    }
  },
  {
    path: '/service-agreement',
    name: 'ServiceAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/service-agreement.vue')
  },
  {
    path: '/privacy-agreement',
    name: 'PrivacyAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/privacy-agreement.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
